import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../service/server/server.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MessageService } from '../../service/message/message.service';

@Component({
  selector: 'app-wharehouse-last-price-sale',
  templateUrl: './wharehouse-last-price-sale.component.html',
  styleUrls: ['./wharehouse-last-price-sale.component.scss']
})
export class WharehouseLastPriceSaleComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public loading: boolean = false;
  public subscription: Subscription | any;
  public user_id: number | undefined;
  public list_record: any = [];
  public server!: any;
  public search!: string;
  public creator!: any;
  public material_id!: any;
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  public dataSource: any | undefined;
  public displayedColumns2 = ['row', 'invoice_date', 'invoice_number', 'invoice_price'];

  constructor(
    public serverService: ServerService,
    public router: Router,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public messageService: MessageService,
    public matDialogRef: MatDialogRef<WharehouseLastPriceSaleComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,) {
    if (this.dialog_data) {
      this.creator = dialog_data.creator;
      this.material_id = dialog_data.material_id;
    }
  }//end consructor
  ngOnInit() {
    this.server = this.serverService.get_server();
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.get_orders(1);
  }
  get_orders(loading: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var obj = {
      'address': 7254,
      'search': this.search,
      'creator': this.creator,
      'material_id': this.material_id,
    }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        this.list_record = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_record.push(res['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  select(i: number) {
    this.matDialogRef.close({ price: this.list_record[i].wharehouse_order_cost });
  }
  close() {
    this.matDialogRef.close();
  }
  //************************************************************************************************** */
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end ifcription2.unsubscribe();
  }//end OnDestroy
}

